import {
  Box,
  Button,
  MenuItem,
  Popover,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { setIsBookmarkSidebar, setSubPopup } from "context/features/dataSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";

const BookmarkHeader = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();

  const { collectionIdArray } = useSelector((state) => state.data);
  const [anchorEl, setAnchorEl] = useState(null);
  const isPopoverOpen = Boolean(anchorEl);

  const getSelectedOption = () => {
    const path = location.pathname;
    if (path.includes("/work-cited")) return "workcited";
    if (path.includes("/collection-notes")) return "collectionnotes";
    return "bookmarks";
  };

  const selectedOption = getSelectedOption();

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const getBookmarkSxProps = (option) => ({
    fontStyle: "italic",
    cursor: "pointer",
    textDecoration: selectedOption === option ? "underline" : "none",
    textDecorationThickness: "2px",
    textUnderlineOffset: "8px",
    color: selectedOption === option ? theme.palette.primary.main : "#696b6c",
  });

  const handlePopoverOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  return (
    <Stack my={2} direction="row" alignItems="center">
      <Stack mb="8px" direction="row" justifyContent="center" gap={3}>
        <Link style={{ textDecoration: "none" }} to={`/collections/${id}`}>
          <Typography variant="h5" sx={getBookmarkSxProps("bookmarks")}>
            Bookmarks
          </Typography>
        </Link>
        <Link
          style={{ textDecoration: "none" }}
          to={`/collections/${id}/work-cited`}
        >
          <Typography variant="h5" sx={getBookmarkSxProps("workcited")}>
            Works Cited
          </Typography>
        </Link>
        <Link
          style={{ textDecoration: "none" }}
          to={`/collections/${id}/collection-notes`}
        >
          <Typography sx={getBookmarkSxProps("collectionnotes")} variant="h5">
            Collection Notes
          </Typography>
        </Link>
      </Stack>
      <Box>
        <Button
          size="large"
          startIcon={<AddIcon />}
          endIcon={<KeyboardArrowDownIcon />}
          onClick={handlePopoverOpen}
          sx={{ ml: 2 }}
        >
          Create
        </Button>
        <Popover
          anchorEl={anchorEl}
          open={isPopoverOpen}
          onClose={handlePopoverClose}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <MenuItem
            sx={{
              p: 2,
              "&:hover": {
                backgroundColor: theme.palette.secondary.main,
              },
            }}
            onClick={() => {
              dispatch(setIsBookmarkSidebar(true));
              handlePopoverClose();
            }}
          >
            <Typography variant="body1">Create External Bookmark</Typography>
          </MenuItem>
          <MenuItem
            onClick={() => navigate(`/collections/${id}/work-cited/create`)}
            sx={{
              p: 2,
              "&:hover": {
                backgroundColor: theme.palette.secondary.main,
              },
            }}
          >
            <Typography variant="body1"> Create Works Cited</Typography>
          </MenuItem>
          {collectionIdArray.length < 3 && (
            <MenuItem
              onClick={() => {
                dispatch(setSubPopup(true));
                handlePopoverClose();
              }}
              sx={{
                p: 2,
                "&:hover": {
                  backgroundColor: theme.palette.secondary.main,
                },
              }}
            >
              <Typography variant="body1">{`Create Subfolder`}</Typography>
            </MenuItem>
          )}
        </Popover>
      </Box>
    </Stack>
  );
};

export default BookmarkHeader;
